module.exports = __webpack_public_path__ + "static/media/dir-4.77e632a5.jpg";